import React from 'react';

import clsx from 'clsx';

import { Grid, makeStyles } from '@gogame/components';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '8px',
  },
  content: {
    border: `1px dashed ${theme.palette.action.disabled}`,
    borderRadius: '4px',
    width: '100%',
    height: '156px',
  },
  highlight: {
    borderColor: `${theme.palette.text.disabled}`,
    backgroundColor: `${theme.palette.action.hover}`,
  },
}));

const Container = ({ className = '', children, ...props }) => {
  const classes = useStyles();
  return (
    <Grid
      container
      direction={'column'}
      className={clsx(classes.content, className)}
      justifyContent={'center'}
      alignItems={'center'}
      {...props}
    >
      {children}
    </Grid>
  );
};

export default Container;
